import axios from "axios";
import { stringify } from "query-string";
import { createTokenHeader } from "../jwt/auth-axios-common";
import { FxWindow } from "../windows/FxWindows";
import { FxSelectBoxDatas } from "./FxSelectBoxDatas";
import { AttrClass } from "./OpClass";
import { FxOpData } from "./FxOpData";
import { fileSubmit } from "../inputs/FxFile";
import Highcharts from "highcharts";

/**
 *
 */
class FxmsData {
  static TISP = "Thingspire Industrial Service Platform";
  static user;
  static apiUrl = process.env.REACT_APP_FXMS_BASE_URL + "/";
  static isDebug = true;
  static token;
  static mngDiv = null;
  static selectBoxDatas = new FxSelectBoxDatas();
  static inited = false;

  // apiUrl 확인을 위한 콘솔로그 추가
  static {
    console.log("=== Build Environment Check ===");
    console.log("NODE_ENV:", process.env.NODE_ENV);
    console.log("REACT_APP_ENV:", process.env.REACT_APP_ENV);
    console.log("FXMS BASE URL:", process.env.REACT_APP_FXMS_BASE_URL);
    console.log("============================");
  }
  
  static initData(callback) {

    if (FxmsData.inited) {
      callback({});
      return;
    }

    Highcharts.setOptions({
      lang: {
        rangeSelectorZoom: "확대/축소",
      },
      time: {
        timezone: "Asia/Seoul",
        useUTC: false,
      },
      credits: {
        enabled: false,
      }, // 하이차트 credits 링크 제거
    });

    FxmsData.inited = true;

    console.log("*** FxmsData initData ***");

    callback({});
  }

  static isEmpty(val) {
    return val === null || val === undefined || val === "";
  }

  static setMngDiv(mngDiv) {
    if (FxmsData.mngDiv === null && mngDiv.length > 1) {
      FxmsData.mngDiv = mngDiv.substr(1);
      console.log("getFxmsConfig : mngDiv", FxmsData.mngDiv);
    }
  }

  static getMngDivPreTag(name) {
    if (
      FxmsData.mngDiv === null ||
      FxmsData.mngDiv === undefined ||
      FxmsData.mngDiv === ""
    ) {
      return name;
    } else {
      return FxmsData.mngDiv + "-" + name;
    }
  }

  static getJWT()
  {
    return FxmsData.token ? FxmsData.token : localStorage.getItem("FXMS-JWT");
  }

  static getHeader() {
    return createTokenHeader(localStorage.getItem("token"));
  }

  static setUser(user) {
    FxmsData.user = user;
    console.log("getFxmsConfig : user", FxmsData.user);
  }
  static getUser() {
    return FxmsData.user;
  }

  static getFxmsConfig(userNo) {
    return new Promise(function (resolve, reject) {
      FxmsData.GET("fxms/all", {userNo : userNo})
        .then(function (res) {
          console.log("*** getFxmsConfig ***", res);

          let data = res.data;

          // 사용자
          FxmsData.setUser(data.user);

          // 코드
          FxmsData.setCodeList(data.codeList);

          // 성능항목 설정
          FxmsData.setPsItemList(data.psItemList);

          // 환경변수
          FxmsData.setVarList(data.varList);

          // 사용자 대시보드 내역 설정
          FxmsData.setOpList(data.opList, data.attrList, data.menuList);
          
          // 대시보드 데이타
          FxmsData.setUiData(res.data.etcMap);

          // 대시보드 컴포넌트 리스트 데이타
          FxmsData.setUiCompntData(FxmsData.selectBoxDatas.getDatas('component', {}));          

          // 설치위치 데이타
          FxmsData.setInloList(res.data.inloList);

          // dong
          FxmsData.setDongInfo(res.data.dongList[0]);


          resolve(res);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  // 회원정보가 수정되었다면 FX_CF_INLO 쪽도 리프레쉬 해줘야 함. 관련된 내용이 있음.
  // 멤버 정보를 리프레쉬한다.
  // 용도: 회원수정하였을경우 다시 데이터를 가져온다. FX_CO_OP 관련 테이블들은 액션을 하고 리프레시를 못함.
  static refreshMemberInfo(){
    console.log("*** getMember ***");

    let user = new Promise(function (resolve, reject) {
      FxmsData.GET("fxms/member")
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          console.log("*** getMo ***  error  ", error);
          reject(error);
        })
        .finally(function () { });
    }).then(function(rsp){
      FxmsData.setUser(rsp);
    });
  }

  // static getRequestHeader()
  // {
  //   return { headers : { fxmsSessionId : localStorage.getItem('FXMS-SESSIONID') } }
  // }
  static getSelectItemRt(type, para = {}) {
    return FxmsData.selectBoxDatas.getSelectItem(type, para);
  }
  static getDatas(type, para = {}) {
    return FxmsData.selectBoxDatas.getDatas(type, para);
  }
  static getSelectItemRt_OLD(type, para) {
    console.log("*** getSelectItemRt ***", type, para);

    if (type === "code") {
      return new Promise(function (resolve, reject) {
        const ret = [];
        const list = FxmsData.codeMap.get(para.cdClass);
        if (list) {
          for (let cd of list) {
            ret.push({ key: cd.cdCode, text: cd.cdName, fxObject: cd });
          }
        }
        resolve(ret);
      });
    } else if (type === "menu") {
      return new Promise(function (resolve, reject) {
        let list = [];
        for (let menu of FxmsData.getMenuList()) {
          if (menu.subMenuList.length === 0) {
            list.push({ key: menu.opId, text: menu.opName, fxObject: menu });
          } else {
            for (let submenu of menu.subMenuList) {
              list.push({
                key: submenu.opId,
                text: menu.opName + " / " + submenu.opName,
                fxObject: submenu,
              });
            }
          }
        }
        resolve(list);
      });
    } else if (type === "component") {
      return new Promise(function (resolve, reject) {
        let list = [];
        for (let menu of FxmsData.getComponentList()) {
          list.push({ key: menu.opId, text: menu.opName, fxObject: menu });
        }
        resolve(list);
      });
    } else if (type === "inlo") {
      return new Promise(function (resolve, reject) {
        const ret = [];
        const list = FxmsData.getInloList(para);
        if (list) {
          for (let cd of list) {
            ret.push({ key: cd.inloNo, text: cd.inloName, fxObject: cd });
          }
        }
        resolve(ret);
      });
    } else if (type === "list") {
      return new Promise(function (resolve, reject) {
        let list = [];
        for (let s of para.list) {
          list.push({ key: s.id, text: s.val });
        }
        resolve(list);
      });
    }

    let [url, key, text, params, method] = FxmsData.#getItem(type, para);

    if (method === "get") {
      params.filter = para;
      const { page, perPage } = params.pagination;
      const { field, order } = params.sort;
      const query = {
        sort: JSON.stringify([field, order]),
        range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
        filter: JSON.stringify(params.filter),
      };
      const callUrl = `${url}?${stringify(query)}`;

      return new Promise(function (resolve, reject) {
        FxmsData.GET(callUrl)
          .then(function (res) {
            const list = [];
            for (let obj of res.data) {
              list.push({ key: obj[key], text: obj[text], fxObject: obj });
            }
            console.log("*** getSelectItemRt ***", url, para, res);

            resolve(list);
          })
          .catch(function (error) {
            console.log("*** getSelectItemRt ***", url, para, error);
            const list = [];
            list.push({ key: "", text: "ERROR " + type });
            resolve(list);
          })
          .finally(function () { });
      });
    } else {
      return new Promise(function (resolve, reject) {
        const list = [];

        if (url != null) {
          FxmsData.PUT(url, para)
            .then(function (res) {
              res.data.sort(function (a, b) {
                if (a[text] > b[text]) {
                  return 1;
                }
                if (a[text] < b[text]) {
                  return -1;
                }
                return 0;
              });

              for (let obj of res.data) {
                list.push({ key: obj[key], text: obj[text], fxObject: obj });
              }
              console.log("*** #select :: " + url + " ***", para, res);

              resolve(list);
            })
            .catch(function (error) {
              console.log("*** #select ***  error  ", error);

              list.push({ key: "", text: "ERROR " + type });
              resolve(list);
            })
            .finally(function () {
              // console.log('*** #select ***');
            });
        } else {
          reject(new Error("구현되지 않음"));
        }
      });
    }
  }

  static getMo(moNo) {
    return new Promise(function (resolve, reject) {
      FxmsData.GET("fxMo/" + moNo)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          console.log("*** getMo ***  error  ", error);
          reject(error);
        })
        .finally(function () { });
    });
  }

  static getVarList() {
    return new Promise(function (resolve, reject) {
      FxmsData.GET("fxms/var")
        .then(function (res) {
          console.log("*** var *** :: ", res);
          FxmsData.setVarList(res.data);
          resolve(res);
        })
        .catch(function (error) {
          console.log("*** get ***  error  ", error);
          reject(error);
        })
        .finally(function () { });
    });
  }

  static getNotLoginData() {
    return new Promise(function (resolve, reject) {
      //FxmsData.GET("fxms/notlogin")

      const para = { mngDiv: FxmsData.mngDiv };
      const callUrl =
        FxmsData.apiUrl + "api/fxms/notlogin?" + `${stringify(para)}`;

      axios
        .get(callUrl)
        .then(function (res) {
          console.log("*** var *** :: ", res);
          FxmsData.setVarList(res.data.varList);
          FxmsData.setOpList(res.data.opList, res.data.opAttrList);
          resolve(res);
        })
        .catch(function (error) {
          console.log("*** get ***  error  ", error);
          reject(error);
        })
        .finally(function () { });
    });
  }

  static get(url, para) {
    console.log("*** get ***   " + url, para);

    const callUrl = para ? `${url}?${stringify(para)}` : url;

    return new Promise(function (resolve, reject) {
      FxmsData.GET(callUrl)
        .then(function (res) {
          console.log("*** get *** :: " + url, para, res);
          resolve(res);
        })
        .catch(function (error) {
          console.log("*** get ***  error  ", error);
          reject(error);
        })
        .finally(function () { });
    });
  }

  /**
   * 그리드용 데이터 조회
   *
   * @param {string} url
   * @param {object} para
   * @param {string} sortAttrName
   * @returns
   */
  static selectGridData(url, para, sortAttrName = "AAA", sortOrder = "ASC") {
    let params = {};
    params.pagination = {};
    params.pagination.page = 1; // 첫 페이지
    params.pagination.perPage = 999999; // 999999건.
    params.filter = para;
    params.sort = {};
    params.sort.order = sortOrder;
    params.sort.field = sortAttrName;

    // 정의되지 않은 내용은 삭제한다.
    for (let key of Object.keys(para)) {
      if (para[key] === null || para[key] === "") {
        delete para[key];
      }
    }

    console.log("*** selectGridData ***   " + url, params);

    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;
    const query = {
      sort: JSON.stringify([field, order]),
      range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
      filter: JSON.stringify(params.filter),
    };
    const callUrl = `${url}?${stringify(query)}`;

    return new Promise(function (resolve, reject) {
      FxmsData.GET(callUrl)
        .then(function (res) {
          console.log("*** selectGridData *** :: " + url, para, res);
          resolve(res);
        })
        .catch(function (error) {
          console.log("*** selectGridData ***  error  ", error);
          reject(error);
        })
        .finally(function () { });
    });
  }

  /**
   * 대시보드 설정한 내용을 기록한다.
   * @param {FxUiGrpItem} fxUiGrpItem
   * @param {object} inObj
   * @returns
   */
  static updateUi(fxUiGrp, fxUiGrpItem, inObj) {
    console.log("updateUi", fxUiGrpItem, inObj);

    let uiGrp = {};
    uiGrp.userNo = FxmsData.getUser().userNo;
    uiGrp.uiGrpNo = fxUiGrpItem.uiGrpNo;
    uiGrp.uiGrpName = fxUiGrp.uiGrpName;
    uiGrp.opId = fxUiGrp.opId;
    uiGrp.dispYn = "Y";
    uiGrp.sortSeq = 0;

    let uiGrpItem = {};
    uiGrpItem.userNo = uiGrp.userNo;
    uiGrpItem.uiGrpNo = uiGrp.uiGrpNo;
    uiGrpItem.uiNo = fxUiGrpItem.uiNo;
    uiGrpItem.opId = fxUiGrpItem.opId;
    uiGrpItem.uiTitle = fxUiGrpItem.opObj.opTitle + "#" + fxUiGrpItem.uiNo;
    uiGrpItem.uiStyle = fxUiGrpItem.uiStyle;
    uiGrpItem.uiX = fxUiGrpItem.uiX;
    uiGrpItem.uiY = fxUiGrpItem.uiY;
    uiGrpItem.uiWdth = fxUiGrpItem.uiWdth;
    uiGrpItem.uiHght = fxUiGrpItem.uiHght;
    uiGrpItem.dispYn = "Y";
    uiGrpItem.sortSeq = 0;

    let uiGrpItemAttrList = [];

    for (const [key, value] of Object.entries(inObj)) {
      if (value) {
        let fxUiGrpItemAttr = {};
        fxUiGrpItemAttr.userNo = uiGrpItem.userNo;
        fxUiGrpItemAttr.uiGrpNo = uiGrpItem.uiGrpNo;
        fxUiGrpItemAttr.uiNo = uiGrpItem.uiNo;
        fxUiGrpItemAttr.attrName = key;
        fxUiGrpItemAttr.attrVal = value;
        fxUiGrpItemAttr.attrType = "aaa";

        uiGrpItemAttrList.push(fxUiGrpItemAttr);
      }
    }

    let para = {
      uiGrp: uiGrp,
      uiGrpItem: uiGrpItem,
      uiGrpItemAttrList: uiGrpItemAttrList,
    };

    FxmsData.update("/fxUrUser/ui", para)
      .then(function (res) {
        FxWindow.alert("변경 내용이 기록되었습니다.");
      })
      .catch(function (error) {
        FxWindow.alert("요청한 내용 처리중 오류가 발생하였습니다.", true);
      });
  }

  static updateUiLayout(uiGrpItemList) {
    let para = {
      uiGrpItemList: uiGrpItemList,
    };

    FxmsData.update("/fxUrUser/ui/layout", para)
      .then(function (res) {
        FxWindow.alert("변경된 레이아웃이 기록되었습니다.");
      })
      .catch(function (error) {
        FxWindow.alert("변경된 레이아웃 처리중 오류가 발생하였습니다.", true);
      });
  }

  /**
   * 대시보드에 컴포넌트를 추가한다
   * @param {number} uiGrpNo 화면그룹번호
   * @param {object} opObj
   * @param {number} uiX
   * @param {number} uiY
   * @returns
   */
  static addUiGrpItem(uiGrpNo, opObj, uiX , uiY ) {    
    const fxUiGrp = FxmsData.getUiGrp(uiGrpNo);       
    const para = FxmsData.makeUiGrpItem(uiGrpNo, opObj, uiX, uiY);
   
    return FxmsData.update("fxUrUser/ui", para);
  }

  static addUiDashItem(uiGrpNo, opObj, uiX , uiY ) {    
    const fxUiGrp = FxmsData.getUiGrp(uiGrpNo);       
    const para = FxmsData.makeUiGrpItem(uiGrpNo, opObj, uiX, uiY);
   
    return FxmsData.update("fxUrUser/ui", para);
  }

  static makeUiGrpItem(uiGrpNo, opObj, uiX , uiY ){
    // 다음 uiNo 구하기
    const fxUiGrp = FxmsData.getUiGrp(uiGrpNo);
    let uiNo = 0;
    if (fxUiGrp && fxUiGrp.fxUiGrpItemList) {
      for (let fxUiGrpItem of fxUiGrp.fxUiGrpItemList) {
        if (fxUiGrpItem.uiNo > uiNo) {
          uiNo = fxUiGrpItem.uiNo;
        }
      }
    }
    uiNo++;

    let uiGrp = {};
    uiGrp.userNo = FxmsData.getUser().userNo;
    uiGrp.uiGrpNo = uiGrpNo;
    uiGrp.uiGrpName = "Dashboard#" + uiGrpNo;
    uiGrp.opId = "ui-dashboard-" + uiGrpNo;
    uiGrp.dispYn = "Y";
    uiGrp.sortSeq = 0;

    let uiGrpItem = {};
    uiGrpItem.userNo = uiGrp.userNo;
    uiGrpItem.uiGrpNo = uiGrp.uiGrpNo;
    uiGrpItem.uiNo = uiNo;
    uiGrpItem.opId = opObj.opId;
    uiGrpItem.uiTitle = opObj.opTitle + "#" + uiNo;
    uiGrpItem.uiStyle = opObj.uiCmptName;
    uiGrpItem.uiX = uiX;
    uiGrpItem.uiY = uiY;
    uiGrpItem.uiWdth = 50;
    uiGrpItem.uiHght = 25;
    uiGrpItem.dispYn = "Y";
    uiGrpItem.sortSeq = 0;

    let para = {
      uiGrp: uiGrp,
      uiGrpItem: uiGrpItem,
    };

    return para;
  }

  static removeUiGrpItem(uiGrpNo, uiNo) {
    console.log("removeUiGrpItem", uiGrpNo + "," + uiNo);

    let para = {
      userNo: FxmsData.getUser().userNo,
      uiGrpNo: uiGrpNo,
      uiNo: uiNo,
    };

    return FxmsData.update("fxUrUser/ui/grpItemDel", para);
  }

  static #getItem(type, para) {
    let params = {};
    params.pagination = {};
    params.pagination.page = 1; // 첫 페이지
    params.pagination.perPage = 999; // 999건.
    params.filter = {};
    params.sort = {};
    params.sort.order = "ASC";

    if (type === "mo") {
      return ["fxms/mo", "moNo", "moName", null, "put"];
    } else if (type === "psItem") {
      return ["fxms/psItem", "psId", "psName", null, "put"];
    } else if (type === "pipe") {
      return ["fxms/pipe", "pipeId", "pipeName", null, "put"];
    } else if (type === "inlo") {
      params.sort.field = "inloName";
      return ["fxms/inlo", "inloNo", "inloName", params, "get"];
    } else if (type === "model") {
      params.sort.field = "modelName";
      return ["fxms/model", "modelNo", "modelName", params, "get"];
    } else if (type === "alarmCfg") {
      params.sort.field = "alarmCfgName";
      return ["fxms/alarmCfg", "alarmCfgNo", "alarmCfgName", params, "get"];
    } else if (type === "alarmCode") {
      params.sort.field = "alcdName";
      return ["fxms/alarmCode", "alcdNo", "alcdName", params, "get"];
    } else if (type === "user") {
      params.sort.field = "userName";
      return ["fxms/user", "userNo", "userName", params, "get"];
    } else if (type === "usergroup") {
      params.sort.field = "ugrpName";
      return ["fxms/usergroup", "ugrpNo", "ugrpName", params, "get"];
    } else if (type === "facility") {
      params.sort.field = "facName";
      return ["feFacility/all", "facNo", "facName", para, "put"];
    }

    return [null, null, null, null, "get"];
  }

  static setLocalStorage(userNo, token) {
    console.log(" setLocalStorage ", userNo, token);
    // localStorage.setItem('sid', data.sessionId);
    // localStorage.setItem('FXMS-SESSIONID', data.sessionId);
    localStorage.setItem("FXMS-USERNO", userNo);
    localStorage.setItem("FXMS-TIME", new Date().getTime());
    localStorage.setItem("FXMS-JWT", token);

    FxmsData.token = token;
  }

  static removeLocalStorage() {
    //localStorage.clear();
    //localStorage.removeItem("sid");
    //localStorage.removeItem("FXMS-SESSIONID");
    // localStorage.removeItem("FXMS-TIME");
    localStorage.removeItem("FXMS-USERNO");
    localStorage.removeItem("plantInfoJson");

  }

  static getUserNo() {
    let no = localStorage.getItem("FXMS-USERNO");
    if (no == null) {
      return -1;
    }
    return parseInt(no);
  }

  static getLocalStorage() {
    return (
      "sid=" +
      localStorage.getItem("sid") +
      ",FXMS-SESSIONID=" +
      localStorage.getItem("FXMS-SESSIONID") +
      ",FXMS-USERNO=" +
      localStorage.getItem("FXMS-USERNO")
    );
  }

  /**
   *
   * 대시보드
   *
   */

  static uiGrpMap = new Map(); // UI그룹 관리용 맵
  static uiCompntList = []; // UI 컴포넌트 리스트 맵

  /**
   *
   * @param {*} data
   */

  static reloadUiData(callback) {
    FxmsData.get("fxUrUser/ui/" + FxmsData.getUser().userNo, {}).then(function (
      res
    ) {
      FxmsData.setUiData(res.data);
      if (callback) {
        callback();
      }
    });
  }

  static setUiData(data) {
    const map = new Map();

    for (let grp of data.uiGrpList) {
      map.set(grp.uiGrpNo, grp);

      grp.opObj = FxmsData.getOpObj(grp.opId);

      for (let item of data.uiGrpItemList) {
        if (item.uiGrpNo === grp.uiGrpNo) {
          item.opObj = FxmsData.getOpObj(item.opId);

          if (grp.fxUiGrpItemList) {
            grp.fxUiGrpItemList.push(item);
          } else {
            grp.fxUiGrpItemList = [item];
          }

          for (let attr of data.uiGrpItemAttrList) {
            if (item.uiGrpNo === attr.uiGrpNo && item.uiNo === attr.uiNo) {
              if (item.attrObj === undefined) {
                item.attrObj = {};
              }
              item.attrObj[attr.attrName] = attr.attrVal;
            }
          }
        }
      }
    }

    FxmsData.uiGrpMap = map;
  }
  static setUiCompntData(compntList) {    
    for (let grp of compntList) {
      grp.opObj = FxmsData.getOpObj(grp.opId);        
    }
    FxmsData.uiCompntList = compntList;
  }

  /**
   *
   * @returns Map
   */
  static getUiGrpMap() {
    return FxmsData.uiGrpMap;
  }

  /**
   * 대시보드 정보 조회
   * @param {number} uiGrpNo
   * @returns
   */
  static getUiGrp(uiGrpNo) {
    const uiGrp = FxmsData.uiGrpMap.get(uiGrpNo);
    return uiGrp;
  }

   /**
   * 대시보드 컴포넌트 조회
   * @param {} 
   * @returns
   */
   static getUiCompnt() {
    const uiGrp = FxmsData.uiCompntList;
    return uiGrp;
  }

  /**
   *
   * @returns UI그룹번호 목록
   */
  static getUiGrpList() {
    let ret = [];
    for (var [key, value] of FxmsData.uiGrpMap) {
      ret.push(value);
    }
    return ret;
  }

  /**
   * ---------------------------------------------------------------------------------------- 운용코드<br>
   *
   *
   *
   */

  static opData;

  /**
   *
   * 운용코드
   *
   * @param {*} opList
   * @param {*} attrList
   */

  static setOpList(opList, attrList, menuList) {
    FxmsData.opData = new FxOpData(opList, attrList, menuList);
    FxmsData.selectBoxDatas.setDatas("op", FxmsData.opData.getOpList());

    const selectDatas = [];
    for (let op of FxmsData.opData.getOpList()) {
      if (op.opTypeCd === "MENU") {
        selectDatas.push(op);
      }
    }

    FxmsData.selectBoxDatas.setDatas("menu", selectDatas);
    FxmsData.selectBoxDatas.setDatas(
      "component",
      FxmsData.opData.getComponentList()
    );

    console.log(
      "---------------------------------------------------",
      menuList
    );
  }

  static getOpList() {
    return FxmsData.opData.getOpList();
  }

  static getOpObj(opId) {
    return FxmsData.opData.getOpObj(opId);
  }

  static getMenuList() {
    return FxmsData.opData.getMenuList();
  }

  static getComponentList() {
    return FxmsData.opData.getComponentList();
  }

  /**
   *
   * 성능항목
   *
   */

  // 성능항목
  static psItemMap = new Map();

  static setPsItemList(psItemList) {
    const map = new Map();
    for (let o of psItemList) {
      map.set(o.psId, o);
    }

    FxmsData.psItemMap = map;

    console.log("getFxmsConfig : psItemMap", FxmsData.psItemMap);
  }

  static getPsItem(psId) {
    const ret = FxmsData.psItemMap.get(psId);
    return ret === null || ret === undefined ? null : ret;
  }

  /**
   *
   * 환경변수
   *
   */

  static varList;
  static varMap;

  static setVarList(varList) {
    FxmsData.varList = varList;
    FxmsData.varMap = new Map();
    for (let o of varList) {
      FxmsData.varMap.set(o.varName, o);
    }

    // console.log("getFxmsConfig : varList", FxmsData.varList, FxmsData.varMap);
  }

  static getVarValue(varName, defVal) {
    if (FxmsData.varMap) {
      const ret = FxmsData.varMap.get(FxmsData.getMngDivPreTag(varName));
      // console.log(
      //   "getFxmsConfig : varList",
      //   FxmsData.getMngDivPreTag(varName),
      //   ret
      // );

      if (ret) {
        return ret.varVal;
      }
    }
    return defVal;
  }

  static setVarValue(varName, val) {
    if (FxmsData.varMap) {
      console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa", FxmsData.getMngDivPreTag(varName));
      const ret = FxmsData.varMap.get(FxmsData.getMngDivPreTag(varName));
      if ( ret ) {
        ret.varVal = val;
      }
    }
  }


  /**
   *
   * 설치위치
   *
   */
  static inloData;
  static setInloList(inloList) {
    FxmsData.inloData = new InloData(inloList);
    FxmsData.selectBoxDatas.setDatas("inlo", inloList);
  }
  static getInlo(inloNo) {
    try {
      return FxmsData.inloData.getInlo(Number(inloNo));
    } catch (error) {
      return null;
    }
  }

  static getInloList(para) {
    return FxmsData.inloData.getInloList(para);
  }


 /**
   *
   * User주소 dong정보
   *
   */
  static dongInfo;
  static setDongInfo(dongInfo) {
    FxmsData.dongInfo = dongInfo;
  }

  static getDongInfo() {
    return FxmsData.dongInfo;
  }

  /**
   *
   * 공통코드
   *
   */
  static codeList = [];
  static codeMap = new Map();

  static setCodeList(codeList) {
    // 코드 정렬
    codeList.sort(function (a, b) {
      if (a.sortSeq > b.sortSeq) {
        return 1;
      }
      if (a.sortSeq < b.sortSeq) {
        return -1;
      }
      return 0;
    });

    // 코드 목록 보관
    FxmsData.codeList = codeList;
    FxmsData.selectBoxDatas.setDatas("code", codeList);

    // 코드 분류로 코드 목록 갖는다.
    var ret;
    const codeMap = new Map();
    for (let cd of codeList) {
      ret = codeMap.get(cd.cdClass);
      if (ret == null) {
        ret = [];
        codeMap.set(cd.cdClass, ret);
      }
      ret.push(cd);
    }
    FxmsData.codeMap = codeMap;

    console.log(
      "getFxmsConfig : codeList",
      FxmsData.codeList,
      FxmsData.codeMap
    );
  }

  static getCodeList(cdClass) {
    let list = FxmsData.codeMap.get(cdClass);
    let ret = [];
    if (list == null) {
      ret.push({ id: "", name: cdClass + " 등록코드 없음" });
    } else {
      for (let cd of list) {
        ret.push({ id: cd.cdCode, name: cd.cdName });
      }
    }
    return ret;
  }

  static fileUpload(para, res) {
    alert("fileUpload");
    const fileInfo = JSON.parse(para.file);
    const fileId = res.data[fileInfo.fileKey];

    localStorage.setItem("fileInfoUrl", fileInfo.fileUrl);
    localStorage.setItem("fileInfoId", fileId);

    fileSubmit();
  }

  static async logout() {
    if (localStorage.getItem("FXMS-USERNO") == null) {
      return Promise.resolve();
    }

    try {
      try {
        const res = await FxmsData.POST("fxUrUser/accsHst/false", {});
        console.log("*** logout *** ", res);
        return await Promise.resolve(res);
      } catch (error) {
        console.log("*** logout *** error ::  ", error);
        return await Promise.reject(error);
      }
    } finally {
      FxmsData.removeLocalStorage();
      FxmsData.token = null;
      document.location.href = "/";
    }
  }

  static update(url, para) {
    console.log("*** update ***   " + url, para);
    return FxmsData.PUT(url, para);
  }

  static insert(url, para) {
    console.log("*** insert ***   " + url, para);
    return FxmsData.POST(url, para);
  }

  static delete(url, para) {
    console.log("*** delete ***   " + url, para);
    return FxmsData.DELETE(url, para);
  }

  static PUT(url, para) {
    console.log("*** PUT ***   " + url, para);

    return new Promise(function (resolve, reject) {
      axios
        .put("/api/" + url, para, FxmsData.getHeader())
        .then(function (res) {
          if (para.file) {
            FxmsData.fileUpload(para, res);
          }
          resolve(res); // FxActionBase에서 메시지 처리하도록 수정

        })
        .catch(function (error) {
          reject(error);
        })
        .finally(function () { });
    });
  }

  static POST(url, para) {
    return new Promise(function (resolve, reject) {
      axios
        .post("/api/" + url, para, FxmsData.getHeader())
        .then(function (res) {
          resolve(res);

          if (para.file) {
            FxmsData.fileUpload(para, res);
          }
        })
        .catch(function (error) {
          reject(error);
        })
        .finally(function () { });
    });
  }

  static DELETE(url) {
    return new Promise(function (resolve, reject) {
      axios
        .delete("/api/" + url, FxmsData.getHeader())
        .then(function (res) {
          resolve(res);
        })
        .catch(function (error) {
          reject(error);
        })
        .finally(function () { });
    });
  }

  static GET(url, para = null) {
    let callUrl;
    if ( para ) {
      callUrl = `${url}?${stringify(para)}`;
    } else {
      callUrl = `${url}`;
    }
    console.log("*** GET ***   " + url, para);

    return new Promise(function (resolve, reject) {
      axios
        .get("/api/" + callUrl, FxmsData.getHeader())
        .then(function (res) {
          console.log("*** GET ***   " + callUrl, res);

          resolve(res);
        })
        .catch(function (error) {
          console.log("*** GET ***   " + callUrl, error);

          reject(error);
        })
        .finally(function () { });
    });
  }
}

/**
 * ***************************************************************************************
 *
 * 설치위치 관련 데이터
 *
 * ***************************************************************************************
 */
class InloData {
  constructor(list) {
    this.inloList = list;
    this.map = new Map();

    for (const inlo of list) {
      this.map.set(Number(inlo.inloNo), inlo);
    }

    console.log("getFxmsConfig : InloData", this.inloList, this.map);
  }

  /**
   *
   * @param {number} inloNo
   * @returns
   */
  getInlo(inloNo) {
    const ret = this.map.get(inloNo);
    if (ret) {
      return ret;
    }

    return this.map.get(inloNo + "");
  }

  /**
   *
   * @param {string} inloClCd
   * @returns
   */
  getInloList(para) {
    if (para === null || para === undefined) {
      return this.inloList;
    }

    const keys = Object.keys(para);
    if (keys.length === 0) {
      return this.inloList;
    }

    const ret = [];
    let match;
    for (let data of this.inloList) {
      match = true;
      for (let key of keys) {
        if (data[key] !== para[key]) {
          match = false;
          break;
        }
      }
      if (match) {
        ret.push(data);
      }
    }

    return ret;
  }
}

export { FxmsData };
